export const SAVED_PROJECTS_REQUESTED = "SAVED_PROJECTS_REQUESTED";
export const SAVED_PROJECTS_RECEIVED = "SAVED_PROJECTS_RECEIVED";
export const SAVED_PROJECTS_REQUEST_FAILED = "SAVED_PROJECTS_REQUEST_FAILED";

export const DELETE_PROJECT_REQUESTED = "DELETE_PROJECT_REQUESTED";
export const DELETE_PROJECT_RECEIVED = "DELETE_PROJECT_RECEIVED";
export const DELETE_PROJECT_REQUEST_FAILED = "DELETE_PROJECT_REQUEST_FAILED";
export const DELETE_PROJECT_RESET = "DELETE_PROJECT_RESET";

export const requestSavedProjects = (pageNumber = 1, pageSize = 10) => ({
  type: SAVED_PROJECTS_REQUESTED,
  pageNumber,
  pageSize
});

export const receiveSavedProjects = (pageSize, pageNumber, total, items) => ({
  type: SAVED_PROJECTS_RECEIVED,
  pageSize,
  pageNumber,
  total,
  items
});

export const requestDeleteProject = projectId => ({
  type: DELETE_PROJECT_REQUESTED,
  id: projectId
});

export const deleteProjectSuccess = () => ({
  type: DELETE_PROJECT_RECEIVED
});

export const resetDeleteProject = () => ({
  type: DELETE_PROJECT_RESET
});
